module.exports = "/packs/images/pages/business_sectors/business-sector-hero-leisure~9899b5b7e506d1f99008c1bfc9aad327.jpg";